module.exports = __webpack_public_path__ + "img/blog_menu_pic13.6da4f35c.png";